import React, { useEffect } from 'react';
import { observer } from 'mobx-react';

import UIStore from '@/stores/UIStore';
import UserStore from 'stores/UserStore';
import PasswordReset from 'components/PasswordReset';
import { Result } from 'antd';

export const PasswordSetup = observer(props => {
    useEffect(() => {
        UIStore.setSelectedKey(['quote']);
        UIStore.setDocumentTitle('Set Password');
    }, []);

    const { user_uid, user_token } = props?.location?.state || {};

    return (
        <React.Fragment>
            <Result
                status={'success'}
                title={'Thank you for submitting your quote!'}
                subTitle={
                    'We have created an account for you! Set a password and you will be able to see all of your Quotes and Orders submitted to PartsBadger.'
                }
            />
            <div
                style={{
                    maxWidth: 800,
                    margin: 'auto',
                }}
            >
                <PasswordReset
                    uid={user_uid}
                    token={user_token}
                    email={UserStore.getEmail()}
                    cardTitle={'Set a Password for Your New Account'}
                />
            </div>
        </React.Fragment>
    );
});
